/**
 * Takes a blob and converts it to a data URL.
 * @param blob The blob to convert.
 * @returns A promise which resolves to the data URL.
 * @link https://stackoverflow.com/a/20285053
 */
export default function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve: (dataUrl: string) => void, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
